module.exports = __webpack_public_path__ + "img/3.5be9bb7c.png";